import { render } from "./BaseRedButton.vue?vue&type=template&id=4f41db8f"
import script from "./BaseRedButton.vue?vue&type=script&lang=js"
export * from "./BaseRedButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__